export default "__VITE_ASSET__CVD5_83x__"